<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import {FunnelPath} from "@/path";
import Swal from "sweetalert2";
import SelectWithSearch from "../Common/SelectWithSearch.vue";
import {
  WarehousePath,
  LocationPath,
} from "@/path.js";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    SelectWithSearch
  },
  computed : {
    LocationPath(){
        return LocationPath;
    },
    WarehousePath(){
        return WarehousePath;
    }
  },
  data() {
    return {
      title: "Warehouse Inspection Import",
      items: [
        {
          text: "Warehouse Inspection",
        },
        {
          text: "Import",
          active: true,
        },
      ],
      date : null,
      file : null,
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      date_filter : null,
      currentPage : 1,
      reports : [],
      warehouse_id : null,
      location_id : null,
      fields: ['report_generated_date','actions']
    };
  },
  watch: {
    currentPage(){
      this.getReports();
    }
  },
  mounted(){
    this.getReports();
  },
  methods : {
    async saveData(){
      try {
        if(this.date == null){
            Swal.fire('Please Select Date','','error');
            return;
        }
        if(this.warehouse_id == null || this.warehouse_id == ''){
            Swal.fire('Please Select Warehouse','','error');
            return;
        }
        if(this.location_id == null || this.location_id == ''){
            Swal.fire('Please Select Location','','error');
            return;
        }
        let formData = new FormData();
        formData.append('date',this.date);
        formData.append('warehouse_id',this.warehouse_id);
        formData.append('location_id',this.location_id);
        formData.append('file',this.file);
        let res = await axios.post(this.baseUrl + FunnelPath.Warehouse_Inspection_Import,formData,{
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if(res.data.status){
          Swal.fire('success','','success');     
          window.location.reload();     
        }
      }catch (err){
        console.log(err);
      }
    },
    async downloadData(){
      try {
        let res = await axios.get(this.baseUrl + FunnelPath.Warehouse_Inspection_EXPORT,{
          params : {
            date : this.date,
            warehouse_id : this.warehouse_id,
            location_id : this.location_id
          }
        });
        if(res.data.status){
          window.location.href = res.data.data.url;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async downloadGravy(){
      window.open('/gravy.csv','_blank');
    },
    async downloadPackaging(){
        window.open('/packaging.csv','_blank');
    },
    async getReports(){
      try {
        // let res = await axios.get(this.baseUrl + FunnelPath.STOCKOUT_REPORTS,{
        //   params : {
        //     date : this.date_filter,
        //     page: this.currentPage
        //   }
        // });
        // if(res.data.status){
        //    this.reports = res.data.data;
        // }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-body>
        <b-row>
            <b-col>
                <b-form-group>
                        <b-button style="margin-left: 10px;" variant="success" @click="downloadGravy">Download Gravy Sample</b-button>
                        <b-button style="margin-left: 10px;" variant="success" @click="downloadPackaging">Download Packaging Sample</b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="4">
                <b-form-group>
                    <label>Date</label>
                    <b-datepicker v-model="date"></b-datepicker>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group>
                    <label>Warehouse</label>
                    <SelectWithSearch
                        :search_api="WarehousePath.WAREHOUSE_SEARCH"
                        track_by="id"
                        display="name"
                        @selectedOption="(v) => (warehouse_id = v)"
                    ></SelectWithSearch>
                </b-form-group>
            </b-col>
            <b-col sm="4">
                <b-form-group>
                    <label>Location</label>
                    <SelectWithSearch
                        :search_api="LocationPath.LOCATION_SEARCH"
                        track_by="id"
                        display="location"
                        @selectedOption="(v) => (location_id = v)"
                    ></SelectWithSearch>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label>Csv File Upload</label>
                    <b-form-file accept=".csv" @change="((e) => file = e.target.files[0])"></b-form-file>                
                </b-form-group>
            </b-col>
            <b-col sm="6">
                
            </b-col>
        </b-row>                        
        <b-form-group>
          <b-button variant="success" @click="saveData">Update Inspection</b-button>
          &nbsp;&nbsp;&nbsp;Or 
          <b-button style="margin-left: 10px;" variant="success" @click="downloadData">
                <i class="fa fa-download"> Download Report</i>
            </b-button>          
        </b-form-group>        
      </b-card-body>      
    </b-card>
  </Layout>
</template>
